import { clsx } from "clsx";
import { type ReactNode } from "react";

type PriceProps = {
  title: ReactNode;
  value: string;
  column?: boolean;
  type: "primary" | "secondary" | "tertiary";
  hidden?: boolean;
};

export const Price = ({ title, value, column, type, hidden }: PriceProps) => {
  if (hidden) return null;

  return (
    <div
      className={clsx("flex items-baseline justify-between", {
        "flex-col !items-end": column
      })}
    >
      <span
        className={clsx({
          "text-text-disabled text-lg font-medium": type === "tertiary",
          "text-lg font-bold text-text-secondary": type === "secondary",
          "text-3xl font-bold text-text-primary": type === "primary"
        })}
      >
        {title}
      </span>

      <span
        className={clsx({
          "text-5xl text-primary-dark": type === "primary",
          "text-lg font-bold text-text-secondary": type === "secondary",
          "text-lg font-medium text-text-disabled": type === "tertiary"
        })}
      >
        {value}
      </span>
    </div>
  );
};
